<template>
    <div class="courses" :class="{checkMobile}">
        <div class="courses_title" v-if="certificates">
            <p>{{$t("profile.certificados")}}</p>
            <div class="pagination">
                <div v-for="i in totalPages" :key="i" :class="{active: i === currentPage}" class="spot"
                     @click="currentPage = i">
                    <p>{{ i + 1 }}</p>
                </div>
            </div>
        </div>
        <div class="courses_title" v-else-if="canEdit">
            <p>{{$t("profile.meus_cursos")}}</p>
            <div class="pagination">
                <div v-for="i in totalPages" :key="i" :class="{active: i === currentPage}" class="spot"
                     @click="currentPage = i">
                    <p>{{ i + 1 }}</p>
                </div>
            </div>
        </div>
        <div class="courses_title" v-else>
            <p>{{$t("profile.cursos_em_comum")}}</p>
            <div class="pagination">
                <div v-for="i in totalPages" :key="i" :class="{active: i === currentPage}" class="spot"
                     @click="currentPage = i">
                    <p>{{ i + 1 }}</p>
                </div>
            </div>
        </div>
        <div class="courses_list" v-if="courses">
            <div class="course_container" v-for="(course) in coursesShow" @click="goTo(course.lms_slug,certificates?'':course.slug)" :key="course.id">
                <div class="course_thumb">
                    <div v-if="certificates" :src="course.url" class="course_thumb_image" :style="'background-image: url(' + course.url + ')'" alt=""></div>
                    <div v-else-if="course.thumbnail" :src="course.thumbnail" class="course_thumb_image" :style="'background-image: url(' + course.thumbnail + ')'" alt=""></div>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>
                </div>
                <div class="course_title">
                    <p>{{course.title}}</p>
                </div>
                <div class="course_description">
                    <p v-if="course.description" v-html="course.description"></p>
                    <p v-else></p>
                </div>
            </div>
            <div class="no_data" v-if="courses <= 0 && certificates">
                <svg width="88" height="88" viewBox="0 0 88 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.1328 5.08203H58.8686C63.8831 5.08196 67.9249 5.08189 71.1039 5.50927C74.4043 5.95301 77.1829 6.90228 79.3902 9.10932C81.5972 11.3164 82.5465 14.0952 82.9901 17.3956C83.4173 20.5745 83.4173 24.6163 83.4173 29.6308V44.7C83.4173 49.7145 83.4173 53.7563 82.9901 56.9353C82.5465 60.2357 81.5972 63.0143 79.3902 65.2212C77.5642 67.0472 75.3393 68.0189 72.733 68.5495C70.2023 69.0646 67.1494 69.1944 63.5352 69.2329L63.5146 69.2333L62.6919 69.2355C62.3369 70.3509 61.7602 71.412 60.9608 72.35C60.4801 72.9139 60.1897 73.615 60.1307 74.3538C59.7783 78.7696 56.2715 82.2764 51.8558 82.6287C51.1173 82.6878 50.4159 82.9782 49.8519 83.4589C46.4801 86.3321 41.5213 86.3321 38.1494 83.4589C37.5855 82.9782 36.8844 82.6878 36.1456 82.6287C31.7296 82.2764 28.223 78.7696 27.8706 74.3538C27.8117 73.6153 27.5212 72.9139 27.0406 72.35C26.2423 71.4131 25.6658 70.3538 25.3111 69.2403C21.4966 69.2146 18.3036 69.1112 15.6806 68.6294C12.9013 68.1186 10.536 67.1462 8.61127 65.2216C6.40423 63.0143 5.45497 60.2357 5.01123 56.9353C4.58384 53.7563 4.58391 49.7145 4.58399 44.7V29.6308C4.58391 24.6163 4.58384 20.5745 5.01123 17.3956C5.45497 14.0952 6.40423 11.3164 8.61127 9.10932C10.8183 6.90228 13.5972 5.95301 16.8976 5.50927C20.0765 5.08189 24.1183 5.08196 29.1328 5.08203ZM25.3166 63.7399C25.6717 62.6326 26.2464 61.5795 27.0406 60.6474C27.5212 60.0835 27.8117 59.3824 27.8706 58.6436C28.223 54.2278 31.7296 50.721 36.1456 50.3687C36.8844 50.3096 37.5855 50.0192 38.1494 49.5385C41.5213 46.6653 46.4801 46.6653 49.8519 49.5385C50.4159 50.0192 51.1173 50.3096 51.8558 50.3687C56.2715 50.721 59.7783 54.2278 60.1307 58.6436C60.1897 59.3824 60.4801 60.0835 60.9608 60.6474C61.7539 61.578 62.3281 62.6296 62.6834 63.7355L63.4868 63.7329C67.0995 63.6944 69.6754 63.5591 71.6356 63.1602C73.5221 62.7759 74.6503 62.1827 75.501 61.3324C76.5159 60.3174 77.1774 58.8929 77.5393 56.2023C77.9114 53.4325 77.9173 49.7618 77.9173 44.4987V29.832C77.9173 24.5688 77.9114 20.8981 77.5393 18.1285C77.1774 15.438 76.5159 14.0132 75.501 12.9984C74.486 11.9836 73.0615 11.322 70.3709 10.9602C67.6012 10.5879 63.9305 10.582 58.6673 10.582H29.334C24.0708 10.582 20.4 10.5879 17.6304 10.9602C14.9399 11.322 13.5151 11.9836 12.5004 12.9984C11.4856 14.0132 10.8239 15.438 10.4622 18.1285C10.0898 20.8981 10.084 24.5689 10.084 29.832V44.4987C10.084 49.7618 10.0898 53.4325 10.4622 56.2023C10.8239 58.8929 11.4856 60.3174 12.5004 61.3324C13.393 62.2248 14.596 62.8379 16.6743 63.2196C18.7649 63.6039 21.4992 63.7135 25.3166 63.7399ZM30.2507 22.4987C30.2507 20.9799 31.4819 19.7487 33.0007 19.7487H55.0007C56.5194 19.7487 57.7507 20.9799 57.7507 22.4987C57.7507 24.0175 56.5194 25.2487 55.0007 25.2487H33.0007C31.4819 25.2487 30.2507 24.0175 30.2507 22.4987ZM22.9173 35.332C22.9173 33.8133 24.1485 32.582 25.6673 32.582H62.334C63.8527 32.582 65.084 33.8133 65.084 35.332C65.084 36.8508 63.8527 38.082 62.334 38.082H25.6673C24.1485 38.082 22.9173 36.8508 22.9173 35.332ZM46.2846 53.7248C44.9687 52.6031 43.0327 52.6031 41.7167 53.7248C40.272 54.956 38.4754 55.7004 36.5831 55.8511C34.8595 55.9889 33.4907 57.3573 33.3532 59.081C33.2022 60.9734 32.4581 62.7701 31.2268 64.2147C30.1052 65.5307 30.1052 67.4667 31.2268 68.7827C32.4581 70.2273 33.2022 72.024 33.3532 73.9164C33.4907 75.6401 34.8595 77.0085 36.5831 77.1463C38.4754 77.297 40.272 78.0414 41.7167 79.2726C43.0327 80.3943 44.9687 80.3943 46.2846 79.2726C47.7293 78.0414 49.526 77.297 51.4183 77.1463C53.142 77.0085 54.5104 75.6401 54.6483 73.9164C54.799 72.024 55.5433 70.2273 56.7746 68.7827C57.8962 67.4667 57.8962 65.5307 56.7746 64.2147C55.5433 62.7701 54.799 60.9734 54.6483 59.081C54.5104 57.3573 53.142 55.9889 51.4183 55.8511C49.526 55.7004 47.7293 54.956 46.2846 53.7248ZM47.6244 60.8216C48.7347 59.7854 50.4749 59.8452 51.5111 60.9558C52.5473 62.0661 52.4875 63.8063 51.3769 64.8425L43.52 72.1758C42.4632 73.1618 40.8239 73.1618 39.7671 72.1758L36.6243 69.2425C35.514 68.2063 35.4539 66.4661 36.4903 65.3558C37.5264 64.2452 39.2666 64.1854 40.3769 65.2216L41.6434 66.4037L47.6244 60.8216Z" fill="#E1E1E1"/>
                </svg>
                {{this.canEdit ? $t('profile.you_dont_certificates') : $t('profile.user_dont_certificates')}}
            </div>
            <div class="no_data" v-else-if="courses <= 0">
                <svg xmlns="http://www.w3.org/2000/svg" height="8em" viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"/></svg>
                {{$t('profile.no_courses')}}
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    name: "CoursesList",
    props: {
        courses: {
            type: Array.type,
            default: []
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        certificates: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goTo(lms_slug, slug) {
            this.$router.push({path: `/lms/${lms_slug}/${slug}`});
        },
    },
    data() {
        return {
            currentPage: 0,
        }
    },
    computed: {
        ...mapGetters(['token',"checkMobile"]),
        maxPerPage() {
            if (this.checkMobile)
                return 1;
            return 3;
        },
        coursesShow() {
            let courses = this.courses ? this.courses : [];
            courses = courses.map(course => {
                if(course?.description?.length > 140) {
                    course.description = course.description.substring(0, 140) + '... <a style="color: var(--buttons_color); font-size: 14px; font-weight: 400">Ver mais</a>';
                }
                return course;
            });
            return courses.slice(this.currentPage * this.maxPerPage, (this.currentPage + 1) * this.maxPerPage);
        },
        totalPages() {
            const maxPagesShow = 6;
            let total = this.courses ? Math.ceil(this.courses.length / this.maxPerPage) : 0;
            let pages =Array.from({length: total}, (v, k) => k);
            //only have spots
            if (total <= maxPagesShow) {
                return pages;
            }
            //have more spots than maxPagesShow
            let start = this.currentPage - Math.ceil(maxPagesShow / 2);
            let end = this.currentPage + Math.floor(maxPagesShow / 2);
            if (start < 0) {
                start = 0;
                end = maxPagesShow;
            }
            if (end > total) {
                end = total;
                start = total - maxPagesShow;
            }
            return pages.slice(start, end);
        }
    }
}
</script>

<style scoped lang="scss">
.courses {
  &.checkMobile {
    .courses_list {
      .course_container {
        width: calc(100% - 20px);
      }
    }
  }
  .courses_title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    p {
      font-size: 20px;
      font-family: Hanken Grotesk;
      font-weight: 700;
      color: #706F6F;
    }

    .pagination {
      display: flex;
      justify-content: center;

      .spot {
        width: 16px;
        height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: rgba(177, 177, 177, 1);
        cursor: pointer;
        transition: all 0.3s;
        margin: 0 5px;
        &.active {
          background: var(--buttons_color);
        }
        p {
          display: none;
          font-size: 12px;
          font-family: Hanken Grotesk;
          font-weight: 700;
          color: #706F6F;
        }
      }
    }
  }
  .courses_list {
    display: flex;
    width: 100%;
    height: 440px;
    align-items: center;
    margin-bottom: 60px;
    .course_container {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 30px;
      width: calc(33% - 20px);
      padding: 30px;
      cursor: pointer;
      margin: 1px 10px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
      &:hover {
        transform: scale(1.02);
        transition: 0.3s;
        background: #FFF;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.10);
      }

      .course_thumb {
        width: 90%;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #dbdbdb;
        .course_thumb_image {
          width: 100%;
          height: 150px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      .course_title {
        margin-top: 20px;
        width: 90%;
        height: 50px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        p {
          font-size: 18px;
          color: #706F6F;
          font-weight: 700;
        }
      }

      .course_description {
        width: 90%;
        min-height: 100px;
        text-align: start;
        overflow-y: auto;
        p {
          font-size: 14px;
          color: #706F6F;
          font-weight: 400;
        }
      }

    }
    .no_data {
      width: 100%;
      height: 400px;
      color: #706F6F;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      border: 1px solid #E1E1E1;
      text-align: center;
      background: #FFF;
      svg {
        margin-bottom: 40px;
        fill: #E1E1E1;
      }
    }
  }

}
</style>